import { Component } from '@angular/core';
import { Angulartics2GoogleAnalytics } from 'angulartics2';

@Component({
    selector: 'flo-registration-root',
    templateUrl: './app.component.html',
})
export class AppComponent {
    public isPrintPage: boolean = false;

    constructor(angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics) {
        // required to call start tracking to track route changes
        angulartics2GoogleAnalytics.startTracking();
        // If the url has the word print in it remove the outer container and box
        this.isPrintPage = location.href.indexOf('print') !== -1;

        if (this.isPrintPage) {
            const html: any = document.getElementsByTagName('html')[0];
            const body: any = document.getElementsByTagName('body')[0];
            html.classList.add('white-background');
            body.classList.add('white-background');
        }
    }
}
